/**
 * @title Api Documentation
 * @description Api Documentation
 * @version 1.0
 *
 * Swagger version 2.0
 * Generated at: Fri Mar 19 2021 14:56:25 GMT+0100 (czas środkowoeuropejski standardowy)
 */

import { API_URLS } from '../utils/config';
import { request } from '../utils/request';
import prepareQueryParams from 'utils/prepareQueryParams';

const URL = API_URLS.STATISTICS;

export interface AbstractResponse<D, L> {
  code: string;
  data: D;
  description: string;
  list: Array<L>;
  message: string;
}

export interface JobExecutionResponse {
  code: string;
  description: string;
  errorfile: string;
  jobid: number;
  logfile: string;
  message: string;
  outputfile: string;
  servicename: string;
}

export interface StatProductionResponse {
  assetcat: string;
  assetcategorylabel: string;
  assettype: string;
  assettypelabel: string;
  branchname: string;
  brid: number;
  brokername: string;
  canceledcttotalfinancedamount: number;
  canceledcttotalnumber: number;
  mgid: number;
  networkcode: string;
  networklabel: string;
  newcttotalfinancedamount: number;
  newcttotalfinservamount: number;
  newcttotalfinservnumber: number;
  newcttotalnumber: number;
  newcttotalservicerevenue: number;
  newcttotalservnumber: number;
  offerid: number;
  offerlabel: string;
  outstandingtotalfinancedamount: number;
  outstandingtotalfinservamount: number;
  percode: string;
  prcode: string;
  productlabel: string;
  stid: number;
  stockintotalnumber: number;
  stockintotalrvamount: number;
  stockoutgainorlossamount: number;
  stockouttotalnumber: number;
  stockouttotalsaleamount: number;
  totalcommissionexpense: number;
  totalnotinvoicedrvamount: number;
  totalrentalrevenue: number;
  totalservicerevenue: number;
  tpidbroker: number;
}

export interface GetStatProductionByCriteriaParams {
  assetcategory: string;
  assettype: string;
  brid?: number;
  networkcode: string;
  offerid?: number;
  percodeend: string;
  percodestart: string;
  prcode: string;
  tpidbroker?: number;
}

/**
 * @tags Statistics Controller
 * @summary getStatProductionByCriteria
 */
export function getStatProductionByCriteria(
  params: GetStatProductionByCriteriaParams
) {
  return request.get<AbstractResponse<object, StatProductionResponse>>(
    `${URL}/api/statistics/production` +
      prepareQueryParams({
        assetcategory: params.assetcategory,
        assettype: params.assettype,
        brid: params.brid,
        networkcode: params.networkcode,
        offerid: params.offerid,
        percodeend: params.percodeend,
        percodestart: params.percodestart,
        prcode: params.prcode,
        tpidbroker: params.tpidbroker,
      } as any)
  );
}

export interface CalcProductionStatisticsParams {
  percode: string;
}

/**
 * @tags Statistics Controller
 * @summary calcProductionStatistics
 */
export function calcProductionStatistics(
  params: CalcProductionStatisticsParams
) {
  return request.get<JobExecutionResponse>(
    `${URL}/api/statistics/run/production` +
      prepareQueryParams({ percode: params.percode } as any)
  );
}
